import { usersApiPaths } from '@/hooks/api/_paths'
import { useApiRequest } from '@/lib/http-utils'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'

export function useReactivateAccountMutation(options?: UseMutationOptions) {
  const { apiRequest } = useApiRequest()
  return useMutation({
    mutationKey: ['reactivate-account'],
    mutationFn: async () => {
      const response = await apiRequest({
        path: usersApiPaths.reactivateAccount,
        options: { method: 'POST' },
      })

      if (!response.ok) {
        throw new Error('FAILED_TO_REACTIVATE_ACCOUNT')
      }
    },
    ...options,
  })
}
